import { apiRequest } from './client';
import { WalletTransaction } from '../types';

export function getBalance(token: string) {
  return apiRequest<{ coinBalance: number }>('/wallet/balance', { token });
}

export interface TransactionsResult {
  transactions: WalletTransaction[];
  total: number;
  page: number;
  pageSize: number;
}

export function getTransactions(token: string, page = 1, pageSize = 50) {
  return apiRequest<TransactionsResult>(`/wallet/transactions?page=${page}&pageSize=${pageSize}`, { token });
}

export interface TopupRequestResult {
  transaction: WalletTransaction;
  bankInstructions: string | null;
}

export function requestTopup(token: string, amountVnd: number) {
  return apiRequest<TopupRequestResult>('/wallet/topup', { method: 'POST', token, body: { amountVnd } });
}

/** photoUri is a local file:// (or web blob:) URI from the camera capture. */
export function attachTopupProof(token: string, transactionId: string, photoUri: string) {
  const form = new FormData();
  const filename = photoUri.split('/').pop() ?? `topup-proof-${Date.now()}.jpg`;
  const ext = filename.split('.').pop()?.toLowerCase();
  const mime = ext === 'png' ? 'image/png' : 'image/jpeg';
  form.append('photo', { uri: photoUri, name: filename, type: mime } as unknown as Blob);
  return apiRequest<WalletTransaction>(`/wallet/topup/${transactionId}/proof`, { method: 'POST', token, form });
}

/** Short-lived (5 min) token for loading a topup-proof photo as an <Image>
 * src — NOT the session token. See backend JwtPhotoStrategy. */
export function getTopupProofToken(token: string, transactionId: string) {
  return apiRequest<{ token: string }>(`/wallet/me/topup-proof-token/${transactionId}`, { token });
}

export interface WithdrawResult {
  transaction: WalletTransaction;
  tier: string;
  grossCoins: number;
  feeCoins: number;
  netCoins: number;
  withdrawalFeeBp: number;
}

export function withdraw(token: string, amountCoins: number, password: string) {
  return apiRequest<WithdrawResult>('/wallet/withdraw', {
    method: 'POST',
    token,
    body: { amountCoins, password },
  });
}
